import { render, staticRenderFns } from "./HistoryPrescription.vue?vue&type=template&id=1652a5d0&scoped=true&"
import script from "./HistoryPrescription.vue?vue&type=script&lang=js&"
export * from "./HistoryPrescription.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPrescription.vue?vue&type=style&index=0&id=1652a5d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652a5d0",
  null
  
)

export default component.exports